import { FloatingFormItem } from '@/components/_common';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import { Col, Form, FormInstance, Row, Typography, Radio, Select } from 'antd';
import { useIntl } from 'react-intl';
import ConsolidatedCheckBoxs from './ConsolidatedCheckBoxs';
import ConsolidatedFieldsByFilter from './ConsolidatedFieldsByFilter';
import {
  QuestConsolidatedFilterBy,
  QuestConsolidatedFormValues,
  QuestConsolidatedReportType,
} from '@/core/domain/questReport/Reports/Consolidated/Consolidated.types';

interface Props {
  form: FormInstance<QuestConsolidatedFormValues>;
}

const ConsolidatedForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();
  const { Title } = Typography;

  return (
    <Form form={form}>
      <ReportSelectMonthFields form={form} />

      <Row gutter={[24, 12]}>
        <Col sm={24}>
          <Title level={5}>
            {intl.formatMessage({
              id: 'movementWorkOrdersReport.form.selectReportType',
            })}
          </Title>

          <Form.Item
            name="reportType"
            noStyle
            initialValue={QuestConsolidatedReportType.analytical}
          >
            <Radio.Group optionType="button" buttonStyle="solid" size="large">
              <Radio value={QuestConsolidatedReportType.analytical}>
                {intl.formatMessage({
                  id: 'consolidatedReportStock.form.reportType.analytical',
                })}
              </Radio>

              <Radio value={QuestConsolidatedReportType.synthetic}>
                {intl.formatMessage({
                  id: 'consolidatedReportStock.form.reportType.synthetic',
                })}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col span={24}>
          <ConsolidatedCheckBoxs />
        </Col>

        <Col lg={6} span={24} md={12}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'consolidatedReportStock.form.filterBy',
            })}
            name="filterBy"
            initialValue={QuestConsolidatedFilterBy.description}
          >
            <Select
              allowClear
              style={{ width: '100' }}
              options={[
                {
                  value: QuestConsolidatedFilterBy.manufacturerCode,
                  label: intl.formatMessage({
                    id: 'consolidatedReportStock.form.filterBy.manufacturingCode',
                  }),
                },
                {
                  value: QuestConsolidatedFilterBy.sku,
                  label: intl.formatMessage({
                    id: 'consolidatedReportStock.form.filterBy.internalCode',
                  }),
                },
                {
                  value: QuestConsolidatedFilterBy.barCode,
                  label: intl.formatMessage({
                    id: 'consolidatedReportStock.form.filterBy.barCode',
                  }),
                },
                {
                  value: QuestConsolidatedFilterBy.description,
                  label: intl.formatMessage({
                    id: 'consolidatedReportStock.form.filterBy.description',
                  }),
                },
                {
                  value: QuestConsolidatedFilterBy.manufacturer,
                  label: intl.formatMessage({
                    id: 'consolidatedReportStock.form.filterBy.manufacturer',
                  }),
                },
                {
                  value: QuestConsolidatedFilterBy.group,
                  label: intl.formatMessage({
                    id: 'consolidatedReportStock.form.filterBy.group',
                  }),
                },
                {
                  value: QuestConsolidatedFilterBy.subGroup,
                  label: intl.formatMessage({
                    id: 'consolidatedReportStock.form.filterBy.subGroup',
                  }),
                },
              ]}
            ></Select>
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <ConsolidatedFieldsByFilter />
        </Col>
      </Row>
    </Form>
  );
};

export default ConsolidatedForm;
